import { useMutation, useQueryClient } from "@tanstack/react-query";
import { InterventionTypeInterface } from "../../../models/TicketModule/InterventionType";
import interventionTypeService from "../../../services/ticketService/interventionTypeService";
import { CACHE_KEY_INTERVENTIONTYPES } from "../../../utils/constants";

interface AddInterventionTypesContext {
  previousIntervention: InterventionTypeInterface[];
}

const useAddInterventionType = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    InterventionTypeInterface,
    Error,
    InterventionTypeInterface,
    AddInterventionTypesContext
  >({
    mutationFn: interventionTypeService.Save,

    onMutate: () => {
      const previousIntervention =
        queryClient.getQueryData<InterventionTypeInterface[]>([
          CACHE_KEY_INTERVENTIONTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousIntervention };
    },

    onSuccess: (savedInterventionType) => {
      queryClient.setQueryData<InterventionTypeInterface[]>(
        [
          CACHE_KEY_INTERVENTIONTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (interventionTypes) =>
          interventionTypes
            ? [savedInterventionType, ...interventionTypes]
            : [savedInterventionType]
      );
    },

    onError: (error, newInterventionType, context) => {
      if (!context) return;

      queryClient.setQueryData<InterventionTypeInterface[]>(
        [
          CACHE_KEY_INTERVENTIONTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousIntervention
      );
    },
  });
};

export default useAddInterventionType;
